const buildConsignmentNavigationTargetUrl = ({
  activeSubPage = "form",
  listContext = {},
  recordId,
  status = "all",
} = {}) => {
  const query = new URLSearchParams(listContext.locationSearch || "");
  query.set("status", status || query.get("status") || "all");
  return `/consignment/${recordId}/${activeSubPage}?${query.toString()}`;
};

export { buildConsignmentNavigationTargetUrl };
